import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/common/Logo';

function PendingApprovalPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-surface-muted flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        {/* Logo */}
        <div className="flex items-center justify-center mb-4">
          <Logo className="w-12 h-12 text-accent" />
          <span className="ml-3 text-3xl font-bold text-content tracking-wide">ARGOS</span>
        </div>

        {/* Icon */}
        <div className="flex justify-center">
          <div className="w-20 h-20 bg-warning-subtle rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-warning" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold text-content">
            Compte pendent d'aprovació
          </h1>
          <p className="mt-4 text-content-secondary">
            El teu registre s'ha completat correctament. Un administrador ha de revisar i aprovar el teu compte abans que puguis accedir a la plataforma.
          </p>
          <p className="mt-2 text-sm text-content-muted">
            Rebràs una notificació quan el teu compte sigui aprovat.
          </p>
        </div>

        <div className="pt-4">
          <button
            onClick={() => navigate('/login')}
            className="text-accent hover:text-accent-hover font-medium"
          >
            Tornar a l'inici de sessió
          </button>
        </div>
      </div>
    </div>
  );
}

export default PendingApprovalPage;
